import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=55f0f6d4&"
import script from "./DataGrid.vue?vue&type=script&lang=js&"
export * from "./DataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports